import React, { useState } from 'react';
import { useHistory, Link } from "react-router-dom";
import { showInfoToast } from '../utils/toastMessage';


export const Header = () => {
  const history = useHistory();

  const [durakBilgi] = useState(localStorage.getItem('durak'));
  const [userName] = useState(localStorage.getItem('username'));

  const handleExit = () => {
    localStorage.clear();
    history.push('/login');
    showInfoToast("Çıkış yapıldı");
  }

  return (
    <header className="header">
      <div className="header-wrapper">
        <div className="brand">
          <h1>Kamil Koç</h1>
        </div>
        <div className="exit">
          <Link to={'/voucher'} className="menuLink"><h5>İndirim Kodu</h5></Link>
          <a href={'https://uetds-master-finance-offlinesales-public.ew1p1.k8s.flix.tech/'} target="_blank" rel="noopener noreferrer" className="menuLink"><h5>Yolcu Listesi</h5></a>
          <Link to={'/shuttlelist'} className="menuLink"><h5>Servis Listesi</h5></Link>
          <Link to={'/phonelist'} className="menuLink"><h5>Telefon Listesi</h5></Link>
          <Link to="#" onClick={() => handleExit()} className="menuLink"><h5>Çıkış</h5></Link>
        </div>
      </div>
      {durakBilgi &&
        <div className="header-wrapper">
          <div className="brand"></div>
          <div className="exit">
            <Link to="#" className="menuLink"><h6>{durakBilgi} -- {userName}</h6></Link>
          </div>
        </div>
      }
    </header>
  );
};